import { isWebkit } from '../common/browser';
import { convertPath } from './path';
import { preventClickDefault, GetNextIDCallback } from './utilities';

/**
 * Create a clone of an element, updating its ID and its children's IDs when needed.
 * @function module:utilities.copyElem
 * @param {Element} el - DOM element to clone
 * @param {module:utilities.GetNextIDCallback} getNextId - The getter of the next unique ID.
 * @returns {Element} The cloned element
 */
export const copyElem = function (el: Element, getNextId: GetNextIDCallback) {
    // manually create a copy of the element
    const newEl = document.createElementNS(el.namespaceURI, el.nodeName);

    for (const attr of el.attributes) {
        newEl.setAttributeNS(attr.namespaceURI, attr.nodeName, attr.value);
    }


    // set the copied element's new id
    newEl.removeAttribute('id');
    newEl.id = getNextId();

    // Opera's "d" value needs to be reset for Opera/Win/non-EN
    // Also needed for webkit (else does not keep curved segments on clone)
    if (isWebkit() && el.nodeName === 'path') {
        const fixedD = convertPath(el as SVGPathElement);
        newEl.setAttribute('d', fixedD);
    }

    // now create copies of all children
    el.childNodes.forEach(function (child) {
        switch (child.nodeType) {
            case Node.ELEMENT_NODE:
                newEl.append(copyElem(child as Element, getNextId));
                break;
            case Node.TEXT_NODE:
                newEl.textContent = child.nodeValue;
                break;
            default:
                break;
        }
    });

    const elDataset = (el as any).dataset;
    const newElDataset = (newEl as any).dataset;

    if (elDataset.gsvg) {
        newElDataset.gsvg = newEl.firstChild
    } else if (elDataset.symbol) {
        const ref = elDataset.symbol;
        newElDataset.ref = ref;
        newElDataset.symbol = ref;
    } else if (newEl.tagName === 'image') {
        preventClickDefault(newEl);
    }

    return newEl;
};
